<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-body">
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header">
              <div class="row mb-3">
                <div class="col-8 d-flex mb-3 mb-lg-0 d-flex align-items-center">
                  <router-link
                    class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                    :to="{ name: 'AddCoupon' }"
                    >
                    + Dodaj promo kod
                  </router-link>
                  <treeselect
                    v-model="b2bOrb2c"
                    class="w-25 mx-1 form-control form-control-modern"
                    :options="b2bOrb2cOptions"
                    placeholder="B2B/B2C"
                  />
                </div>
                <div class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0">
                </div>
                <div class="col-4 col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                  <div
                    class="d-flex align-items-lg-center flex-column flex-lg-row"
                  >
                    <select
                      class="form-control select-style-1 results-per-page"
                      name="results-per-page"
                      v-model="searchConfig.pageSize"
                      @change="changePageSize(searchConfig.pageSize)"
                    >
                      <option
                        :value="page"
                        v-for="page in pageSizeList"
                        :key="page"
                      >
                        {{ page }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-lg-auto ps-lg-1">
                  <div
                    class="search search-style-1 search-style-1-lg mx-lg-auto"
                  >
                    <div class="input-group">
                      <input
                        type="text"
                        class="search-term form-control"
                        placeholder="Search"
                        v-model="searchField"
                        @input="debounceInput"
                      />
                      <button class="btn btn-default" type="submit">
                        <i class="bx bx-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr class="solid mt-5 opacity-4" />
            <div
              class="dataTables_wrapper dt-bootstrap5 no-footer"
              v-if="list.length > 0"
            >
              <div class="table-responsive">
                <table
                  class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                >
                  <thead>
                    <tr role="row">
                      <th class="sorting_disabled">
                        <input
                          v-model="selectAll"
                          type="checkbox"
                          class="select-all checkbox-style-1 p-relative top-2"
                        />
                      </th>
                      <th class="sorting">Rbr</th>
                      <th class="sorting">Name</th>
                      <th class="sorting">Discount type</th>
                      <th class="sorting">Discount</th>
                      <th class="sorting">Promo code</th>
                      <th class="sorting">Start date</th>
                      <th class="sorting">End date</th>
                      <th class="sorting">Datum kreiranja</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      role="row"
                      v-for="(item, index) in list"
                      :key="item.id"
                      @click="openDetails(item.id, item.discountApplianceType)"
                      :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }"
                    >
                      <td width="30">
                        <input
                          type="checkbox"
                          class="checkbox-style-1 p-relative top-2"
                          :value="item.id"
                          v-model="selected"
                          @click.stop
                        />
                      </td>
                      <td>
                        <strong>{{
                          (pager.currentPage - 1) * searchConfig.pageSize +
                          index +
                          1
                        }}</strong>
                      </td>
                      <td>
                        <strong>{{ item.title }}</strong>
                      </td>
                      <td>{{ mapDiscountType(item.discountApplianceType) }}</td>
                      <td>
                        {{ item.discount }}%
                      </td>
                      <td>{{ item.code }}</td>
                      <td>{{ formatDate(item.startDate) }}</td>
                      <td>{{ formatDate(item.endDate) }}</td>
                      <td>{{ formatDate(item.createdDate) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <div class="alert alert-info" role="alert">
                {{ translations.noRecords }}
                <a class="alert-link" @click.prevent="resetFilters">{{
                  translations.resetFilters
                }}</a
                >.
              </div>
            </div>
            <div class="row row-gutter-sm justify-content-between mt-4">
              <pagination :action="actionName" :pagination-props="paginationProps" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations, pager } from '@/mixins';
import Pagination from '../shared/Pagination.vue';

export default {
  name: 'Coupons',
  components: { Treeselect, Pagination },
  mixins: [translations, pager],
  data() {
    const { query } = this.$route;

    return {
      actionName: 'getPromoCodes',
      b2bOrb2c: query?.b2b ? 'b2b' : query?.b2c ? 'b2c' : null,
    };
  },
  computed: {
    list() {
      return this.$store.getters.getPromoCodes;
    },
    discountTypes() {
      return [
        {
          id: 1,
          label: 'Popust se odnosi na iznos narudžbe',
        },
        {
          id: 2,
          label: 'Popust se odnosi na proizvode',
        },
        {
          id: 3,
          label: 'Popust se odnosi na kategorije',
        },
        {
          id: 4,
          label: 'Popust se odnosi na brand',
        },
      ];
    },
    b2bOrb2cOptions() {
      return [
        { id: 1, label: 'B2B' },
        { id: 2, label: 'B2C' },
        { id: null, label: 'Sve' },
      ];
    },
    paginationProps() {
      return {
        quickSearch: this.$route.query.search || this.searchConfig.quickSearch,
        businessType: this.b2bOrb2c,
      };
    },
  },
  methods: {
    mapDiscountType(id) {
      return this.discountTypes.find((item) => item.id === id).label;
    },
    openDetails(id, type) {
      this.$router.push({ name: 'EditPromoCode', params: { id: id, type: type } });
    },
    getPromoCodes() {
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
        page: 1,
      });

      this.$router
        .push({
          query: {
            ...this.paginationProps,
            page: 1,
          },
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, this.searchConfig);
  },
  watch: {
    b2bOrb2c() {
      this.getPromoCodes();
    },
  },
};
</script>
<style lang="scss" scoped>
.sorting {
  cursor: pointer;
}

tbody tr {
  cursor: pointer;
}
</style>

<style>
.vue-treeselect__placeholder {
  color: #000;
}

.form-control.form-control-modern.vue-treeselect.vue-treeselect--open-below.vue-treeselect--searchable.vue-treeselect--single.w-25 {
  height: 46px;
}

.vue-treeselect__control {
  border: none;
  background: none;
}
</style>